import { Sparkles } from "lucide-react";

const Half = ({ text }) => (
  <div className="flex shrink-0" aria-hidden="true">
    {Array.from({ length: 4 }, (_, i) => (
      <span key={i} className="inline-flex items-center gap-4 px-6 whitespace-nowrap">
        <Sparkles className="w-4 h-4 text-amber-300 shrink-0" /> {text}
      </span>
    ))}
  </div>
);

export const Ticker = ({ text, rtl }) => (
  <div className="relative overflow-hidden bg-[#8B3A2B] text-[#FAF7F2] text-sm sm:text-base font-semibold py-2.5" data-testid="home-ticker">
    <p className="sr-only">{text}</p>
    <div className={`marquee-track ${rtl ? "" : "marquee-ltr"}`}>
      <Half text={text} />
      <Half text={text} />
    </div>
  </div>
);
